/**
 * 🧠 GROCERY CATEGORY REGISTRY
 * Maps natural language keywords to household aisles.
 * Used by the CategoryManager and the guessCategory engine.
 */

export const CATEGORY_MAP: Record<string, string[]> = {
  Produce: [
    'apple', 'banana', 'carrot', 'broccoli', 'spinach', 'kale', 'lettuce', 
    'tomato', 'onion', 'garlic', 'potato', 'berry', 'blueberries', 'strawberry', 
    'avocado', 'lemon', 'lime', 'orange', 'fruit', 'veg', 'cucumber', 'pepper'
  ],
  Dairy: [
    'milk', 'cheese', 'yogurt', 'butter', 'cream', 'eggs', 'sour cream', 
    'almond milk', 'oat milk', 'parmesan', 'cheddar', 'mozzarella'
  ],
  Proteins: [
    'chicken', 'beef', 'pork', 'steak', 'turkey', 'fish', 'salmon', 'shrimp', 
    'tofu', 'tempeh', 'bacon', 'sausage', 'lamb', 'ground beef'
  ],
  Pantry: [
    'flour', 'sugar', 'rice', 'pasta', 'oil', 'vinegar', 'honey', 'syrup', 
    'cereal', 'oats', 'bread', 'tortilla', 'cracker', 'chips', 'snack', 
    'peanut butter', 'jam', 'canned', 'soup', 'beans', 'lentils', 'quinoa'
  ],
  Frozen: [
    'ice cream', 'pizza', 'frozen', 'peas', 'corn', 'berries', 'waffle', 
    'fries', 'nuggets', 'sorbet'
  ],
  Household: [
    'paper towel', 'toilet paper', 'soap', 'detergent', 'cleaner', 'sponge', 
    'trash bags', 'foil', 'wrap', 'shampoo', 'toothpaste', 'battery'
  ],
  Beverages: [
    'coffee', 'tea', 'juice', 'soda', 'water', 'sparkling', 'wine', 'beer', 
    'kombucha', 'energy drink'
  ]
};

/**
 * 🛰️ CATEGORY HEURISTICS
 * Heuristic function to predict a category based on a task title.
 */
export const guessCategory = (title: string): string => {
  const text = title.toLowerCase();
  
  // Iterate through the map to find a keyword match
  for (const [category, keywords] of Object.entries(CATEGORY_MAP)) {
    if (keywords.some(keyword => text.includes(keyword))) {
      return category;
    }
  }

  return 'General'; // Fallback for unclassified items
};

/**
 * 🎨 CATEGORY STYLES
 * Maps categories to tailwind colors for UI consistency.
 */
export const CATEGORY_COLORS: Record<string, string> = {
  Produce: 'bg-emerald-500',
  Dairy: 'bg-blue-400',
  Proteins: 'bg-rose-500',
  Pantry: 'bg-amber-600',
  Frozen: 'bg-cyan-400',
  Household: 'bg-slate-500',
  Beverages: 'bg-purple-500',
  General: 'bg-indigo-500'
};